import { createGlobalStyle } from 'styled-components';
import { fontFamily } from './Theme';

export const GlobalStyles = createGlobalStyle`
	body {
			font-family: ${fontFamily};
	}
`;
